import { InputFieldComponent } from "./fields/InputField";
import { SelectFieldComponent } from "./fields/SelectField";
import { DatePickerFieldComponent } from "./fields/DatePickerField";
import { CheckboxField } from "./fields/CheckboxField";
import { RangeField } from "./fields/RangeField";
import { TextareaFieldComponent } from "./fields/TextareaField";
import { DisplayField } from "./fields/DisplayField";
import { FormComponent } from "../../shared/utils/enums";
import { SearchableSelect } from "./fields/SearchableSelect";
import { RadioField } from "./fields/RadioField";
import { ImageUploader } from "./fields/ImageUploader";

export type FormComponentType = keyof typeof FormComponent;

export type FormFieldType =
  | "text"
  | "number"
  | "email"
  | "password"
  | "select"
  | "multiselect"
  | "date"
  | "textarea"
  | "checkbox"
  | "radio"
  | "searchableSelect";

export interface FormField {
  name: string;
  label: string;
  type: FormFieldType;
  placeholder?: string;
  options?: { label: string; value: string | number }[];
  validation?: {
    required?: boolean;
    min?: number;
    max?: number;
    pattern?: string;
    message?: string;
  };
  defaultValue?: any;
}

export const formComponents = {
  [FormComponent.Input]: InputFieldComponent,
  [FormComponent.Select]: SelectFieldComponent,
  [FormComponent.DatePicker]: DatePickerFieldComponent,
  [FormComponent.Checkbox]: CheckboxField,
  [FormComponent.Range]: RangeField,
  [FormComponent.Textarea]: TextareaFieldComponent,
  [FormComponent.Display]: DisplayField,
  [FormComponent.SearchableSelect]: SearchableSelect,
  [FormComponent.RadioField]: RadioField,
  [FormComponent.ImageUploader]: ImageUploader,
} as const;